import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";
import moment from "moment";
import { STRING_ID_EMPRESA_ULTIMA_MILLA_V3 } from "./const/string-const";

export const sharedNextPage = (page, params, history) => {
    try {
        // const history = useHistory();
        // history.push(`${page}`);
        // console.log('params');
        // console.log(params);
        if (params !== undefined && params !== null) {
            if (params.acciones !== undefined) {
                delete params.acciones;
            }
            // console.log('params sin acciones');
            // console.log(params);
            history.push({
                pathname: `${page}`,
                state: params
            });
        } else {
            history.push(`${page}`);
        }
    } catch (err) {
        console.log('nextPage err');
        console.log(err);
    }
};

export const sharedOpenNewTab = (page, params) => {
    try {
        // Open the new page in a new tab
        const newWindow = window.open(page, '_blank');

        // Wait until the new page is fully loaded, then send the data
        newWindow.onload = () => {
            console.log('onload');
            newWindow.postMessage(params, window.location.origin);
        };
    } catch (err) {
        console.log('sharedNextPage error:', err);
    }
};

export const sharedMensajeConfirmacion = (message, data) => {
    try {
        return message + ': ' + data;
    } catch (err) {
        return message;
    }
};

/**
 * Validates a decimal number input format:
 * - digits with optional one decimal point
 * - if decimal present: 1 to `maxDecimals` digits after `.` (default 3)
 * - total length up to `maxLength` (default 10)
 * - empty string is allowed (for typing/clearing)
 * - `allowIncomplete`: allow trailing `.` while typing (e.g. "12.")
 * Examples: 12345678.1, 1234567.12, 123456.123, 1.123, 55, 0.5
 */
export const sharedIsValidDecimalNumber = (
    value,
    { maxLength = 10, maxDecimals = 3, allowIncomplete = false } = {}
) => {
    try {
        if (value === "" || value == null) return true;
        const text = String(value);
        if (text.length > maxLength) return false;
        const minDecimals = allowIncomplete ? 0 : 1;
        const numericRegex = new RegExp(
            `^(\\d+(\\.\\d{${minDecimals},${maxDecimals}})?|\\.\\d{${minDecimals},${maxDecimals}})$`
        );
        return numericRegex.test(text);
    } catch (err) {
        console.log("sharedIsValidDecimalNumber err");
        console.log(err);
        return false;
    }
};

export const sharedParseFecha = (fecha) => {
    try {
        if (fecha !== null && fecha !== undefined && fecha !== '') {
            // If it's a Date object, convert it directly
            if (fecha instanceof Date) {
                fecha = moment(fecha).format("YYYY-MM-DD");
            } else {
                // Try to parse as string date (handles MM/DD/YYYY and other formats)
                const parsed = moment(fecha, ["MM/DD/YYYY", "MM-DD-YYYY", "YYYY-MM-DD", "DD/MM/YYYY", "DD-MM-YYYY"], true);
                if (parsed.isValid()) {
                    fecha = parsed.format("YYYY-MM-DD");
                } else {
                    // Try moment's default parsing
                    const defaultParsed = moment(fecha);
                    if (defaultParsed.isValid()) {
                        fecha = defaultParsed.format("YYYY-MM-DD");
                    } else {
                        fecha = null;
                    }
                }
            }
        } else {
            fecha = null;
        }
        return fecha;
    } catch (err) {
        console.log('sharedParseFecha err');
        console.log(err);
        return null;
    }
};

export const sharedExportarLink = (urlDescarga, nombreArchivo) => {
    try {

        const link = document.createElement('a');
        link.href = urlDescarga;
        link.target = '_blank';
        link.setAttribute(
            'download',
            nombreArchivo,
        );

        // Append to html link element page
        document.body.appendChild(link);

        // Start download
        link.click();

        // Clean up and remove the link
        link.parentNode.removeChild(link);
        //      });
    } catch (err) {
        console.log('sharedExportarLink err');
        console.log(err);
    }
};

export const sharedHaversine = (lat1, lon1, lat2, lon2) => {
    try {
        const R = 6371000; // radius of Earth in meters
        const phi1 = lat1 * (Math.PI / 180);
        const phi2 = lat2 * (Math.PI / 180);
        const deltaPhi = (lat2 - lat1) * (Math.PI / 180);
        const deltaLambda = (lon2 - lon1) * (Math.PI / 180);

        const a = Math.sin(deltaPhi / 2) * Math.sin(deltaPhi / 2) +
            Math.cos(phi1) * Math.cos(phi2) * Math.sin(deltaLambda / 2) * Math.sin(deltaLambda / 2);

        const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

        const meters = R * c; // output distance in meters
        // const km = meters / 1000; // output distance in kilometers

        const roundedMeters = Math.round(meters * 1000) / 1000; // round to 3 decimal places

        return roundedMeters;
    } catch (err) {
        console.log('sharedHaversine err');
        console.log(err);
        return null;
    }
};

export const sharedValidarLatLng = (lat, lng) => {
    try {
        // console.log('lat');
        // console.log(lat);
        // console.log('lng');
        // console.log(lng);
        if (lat === undefined || lat === null || String(lat).trim().length === 0 || lat === 'NaN' || String(lat).trim().indexOf('.') === -1) {
            return false;
        }
        if (lng === undefined || lng === null || String(lng).trim().length === 0 || lng === 'NaN' || String(lng).trim().indexOf('.') === -1) {
            return false;
        }
        const latitude = parseFloat(lat);
        const longitude = parseFloat(lng);
        // console.log('latitude');
        // console.log(latitude);
        // console.log('longitude');
        // console.log(longitude);
        if (latitude !== 0 && isNaN(latitude) === false && longitude !== 0 && isNaN(longitude) === false) {
            return true;
        }
        return false;
    } catch (err) {
        console.log('validarLatLng err');
        console.log(lat);
        console.log(lng);
        console.log(err);
        return false;
    }
};

export const sharedObtenerIcon = (vH, isA, eEstado, eVelocidad, id_icono) => {
    let esFlecha = isA;
    let motorEncendido = eEstado === 1;
    let tieneVelocidad = eVelocidad > 0.1;
    let angulo = (((vH + 22.5 > 360 ? vH + 22.5 - 360 : vH) / 45) | 0) * 45;
    if (esFlecha) id_icono = 0;
    let id_color_flecha = 1;
    if (!motorEncendido) id_color_flecha = 2;
    if (motorEncendido && !tieneVelocidad) id_color_flecha = 3;
    return `https://gestion.boltrack.net/assets/icons/${id_icono}_${angulo}_${id_color_flecha}.png`;
};

export const sharedObtenerListaPorAtributo = (atributo, lista) => {
    try {
        let set = new Set();
        lista.forEach((element) => {
            set.add(element[atributo]);
        });
        return Array.from(set);
    } catch (err) {
        return [];
    }
};

/** Zoom level for PDF static map tile (single 256×256 tile, scaled in layout). */
const PDF_STATIC_MAP_ZOOM = 16;

/**
 * Web Mercator tile index for https://tile.openstreetmap.org/{z}/{x}/{y}.png
 * (replaces staticmap.openstreetmap.de — often unreachable / deprecated.)
 */
function latLngToOsmTileXY(lat, lng, zoom) {
    const z = Math.min(19, Math.max(0, Math.round(zoom)));
    const latNum = Number(lat);
    const lngNum = Number(lng);
    if (!Number.isFinite(latNum) || !Number.isFinite(lngNum)) return null;
    const n = 2 ** z;
    const x = Math.floor(((lngNum + 180) / 360) * n);
    const latRad = (latNum * Math.PI) / 180;
    const y = Math.floor(
        ((1 - Math.log(Math.tan(latRad) + 1 / Math.cos(latRad)) / Math.PI) / 2) * n
    );
    return { x, y, z };
}

/**
 * Pixel position (0–256) of lat/lng inside the OSM tile returned by latLngToOsmTileXY (same zoom).
 */
function latLngToPixelInTile(lat, lng, zoom) {
    const z = Math.min(19, Math.max(0, Math.round(zoom)));
    const latNum = Number(lat);
    const lngNum = Number(lng);
    if (!Number.isFinite(latNum) || !Number.isFinite(lngNum)) return null;
    const n = 2 ** z;
    const latRad = (latNum * Math.PI) / 180;
    const xFloat = ((lngNum + 180) / 360) * n;
    const yFloat =
        ((1 - Math.log(Math.tan(latRad) + 1 / Math.cos(latRad)) / Math.PI) / 2) * n;
    const px = (xFloat - Math.floor(xFloat)) * 256;
    const py = (yFloat - Math.floor(yFloat)) * 256;
    return { px, py };
}

/**
 * Static map image URL from coordinates (used in PDF clone only; html2canvas cannot capture cross-origin iframes).
 * Uses the official OSM tile CDN (CORS-friendly for canvas export).
 * @param {string} lat
 * @param {string} lng
 * @returns {string}
 */
function buildPdfStaticMapImageUrl(lat, lng) {
    const tile = latLngToOsmTileXY(lat, lng, PDF_STATIC_MAP_ZOOM);
    if (!tile) return "";
    return `https://tile.openstreetmap.org/${tile.z}/${tile.x}/${tile.y}.png`;
}

function pdfMapCacheKey(lat, lng) {
    return `${String(lat).trim()},${String(lng).trim()}`;
}

/** Raster scale for PDF map (sharper marker + tile in html2canvas). */
const PDF_MAP_CANVAS_SCALE = 2;

function loadImageFromBlob(blob) {
    return new Promise((resolve, reject) => {
        const objectUrl = URL.createObjectURL(blob);
        const img = new Image();
        img.crossOrigin = "anonymous";
        img.onload = () => {
            URL.revokeObjectURL(objectUrl);
            resolve(img);
        };
        img.onerror = () => {
            URL.revokeObjectURL(objectUrl);
            reject(new Error("map tile image load failed"));
        };
        img.src = objectUrl;
    });
}

/**
 * Draws location marker on OSM tile and returns PNG data URL for PDF (html2canvas-ready).
 */
function drawMarkerOnTileCanvas(img, pxInTile, pyInTile) {
    const base = 256;
    const scale = PDF_MAP_CANVAS_SCALE;
    const W = base * scale;
    const H = base * scale;
    const canvas = document.createElement("canvas");
    canvas.width = W;
    canvas.height = H;
    const ctx = canvas.getContext("2d");
    if (!ctx) return null;
    ctx.drawImage(img, 0, 0, W, H);
    const px = pxInTile * scale;
    const py = pyInTile * scale;
    const outerR = Math.max(8, 9 * scale);
    const innerR = 3 * scale;

    ctx.save();
    ctx.shadowColor = "rgba(0,0,0,0.4)";
    ctx.shadowBlur = 6;
    ctx.fillStyle = "#dc2626";
    ctx.beginPath();
    ctx.arc(px, py, outerR, 0, Math.PI * 2);
    ctx.fill();
    ctx.shadowBlur = 0;
    ctx.strokeStyle = "#ffffff";
    ctx.lineWidth = 3 * scale;
    ctx.stroke();
    ctx.fillStyle = "#ffffff";
    ctx.beginPath();
    ctx.arc(px, py, innerR, 0, Math.PI * 2);
    ctx.fill();
    ctx.restore();

    try {
        return canvas.toDataURL("image/png");
    } catch {
        return null;
    }
}

/**
 * Loads OSM tile, composites a lat/lng marker, returns data URL so html2canvas sees a ready image.
 */
async function fetchOsmTileAsDataUrl(lat, lng) {
    try {
        const url = buildPdfStaticMapImageUrl(lat, lng);
        if (!url) return null;
        const pixel = latLngToPixelInTile(lat, lng, PDF_STATIC_MAP_ZOOM);
        if (!pixel) return null;
        const res = await fetch(url, { mode: "cors", credentials: "omit", cache: "force-cache" });
        if (!res.ok) return null;
        const blob = await res.blob();
        if (!blob?.size) return null;

        let img;
        if (typeof createImageBitmap === "function") {
            try {
                const bitmap = await createImageBitmap(blob);
                img = bitmap;
            } catch {
                img = await loadImageFromBlob(blob);
            }
        } else {
            img = await loadImageFromBlob(blob);
        }

        const dataUrl = drawMarkerOnTileCanvas(img, pixel.px, pixel.py);
        if (img && typeof img.close === "function") img.close();
        if (dataUrl) return dataUrl;
        return await new Promise((resolve) => {
            const reader = new FileReader();
            reader.onloadend = () => {
                resolve(typeof reader.result === "string" ? reader.result : null);
            };
            reader.onerror = () => resolve(null);
            reader.readAsDataURL(blob);
        });
    } catch {
        return null;
    }
}

/** Prefetch map tiles for every iframe marker in the live block (before html2canvas runs). */
async function prefetchPdfMapTilesForBlock(block) {
    const mapDataUrlByKey = new Map();
    if (!block || typeof block.querySelectorAll !== "function") return mapDataUrlByKey;
    const iframes = block.querySelectorAll("iframe[data-pdf-map-static]");
    for (let i = 0; i < iframes.length; i++) {
        const iframe = iframes[i];
        const lat = iframe.getAttribute("data-lat");
        const lng = iframe.getAttribute("data-lng");
        if (lat == null || lng == null || String(lat).trim() === "" || String(lng).trim() === "") continue;
        const key = pdfMapCacheKey(lat, lng);
        if (mapDataUrlByKey.has(key)) continue;
        const dataUrl = await fetchOsmTileAsDataUrl(lat, lng);
        if (dataUrl) mapDataUrlByKey.set(key, dataUrl);
    }
    return mapDataUrlByKey;
}

/**
 * Absolute URL key for deduping remote images (signed URLs, CDN, etc.).
 */
function normalizePdfRemoteImageUrl(raw) {
    if (raw == null || typeof raw !== "string") return "";
    const t = raw.trim();
    if (!t || t.startsWith("data:") || t.startsWith("blob:")) return "";
    try {
        return new URL(t, window.location.href).href;
    } catch {
        return "";
    }
}

/**
 * Fetch remote image as data URL so html2canvas can rasterize it (avoids tainted canvas).
 * Requires the host (e.g. GCS bucket) to send Access-Control-Allow-Origin for this app origin.
 */
async function fetchRemoteImageAsDataUrl(url) {
    try {
        const res = await fetch(url, { mode: "cors", credentials: "omit", cache: "force-cache" });
        if (!res.ok) return null;
        const blob = await res.blob();
        if (!blob?.size) return null;
        return await new Promise((resolve) => {
            const reader = new FileReader();
            reader.onloadend = () => {
                resolve(typeof reader.result === "string" ? reader.result : null);
            };
            reader.onerror = () => resolve(null);
            reader.readAsDataURL(blob);
        });
    } catch {
        return null;
    }
}

/** Prefetch & inline remote <img> URLs (photos, firmas on GCS, etc.) for PDF capture. */
async function prefetchPdfRemoteImagesForBlock(block) {
    const imageDataUrlBySrc = new Map();
    if (!block || typeof block.querySelectorAll !== "function") return imageDataUrlBySrc;
    const urlsToFetch = [];
    const seen = new Set();
    const imgs = block.querySelectorAll("img");
    for (let i = 0; i < imgs.length; i++) {
        const img = imgs[i];
        const rawSrc =
            (typeof img.currentSrc === "string" && img.currentSrc ? img.currentSrc : "") ||
            img.getAttribute("src") ||
            "";
        const key = normalizePdfRemoteImageUrl(rawSrc);
        if (!key || seen.has(key)) continue;
        seen.add(key);
        urlsToFetch.push(key);
    }
    await Promise.all(
        urlsToFetch.map(async (key) => {
            const dataUrl = await fetchRemoteImageAsDataUrl(key);
            if (dataUrl) imageDataUrlBySrc.set(key, dataUrl);
        })
    );
    return imageDataUrlBySrc;
}

/**
 * Fixes DOM clone before html2canvas:
 * - Replace Google Maps iframe with a static map image built only from lat/lng (same coords as on screen).
 * - Prefer inlined data URLs from prefetchPdfMapTilesForBlock so the raster is ready before paint.
 * - Replace remote <img> src with prefetchPdfRemoteImagesForBlock data URLs when available.
 * GCS/signed URLs need bucket CORS allowing this origin, otherwise fetch fails and images stay cross-origin.
 */
/**
 * html2canvas often flattens margin between block labels and inputs; force spacing on the clone only.
 */
function applyPdfCloneLabelInputSpacing(clonedRoot) {
    if (!clonedRoot || typeof clonedRoot.querySelectorAll !== "function") return;
    clonedRoot.querySelectorAll("label").forEach((label) => {
        const next = label.nextElementSibling;
        if (!next) return;
        const tag = next.tagName && String(next.tagName).toLowerCase();
        if (tag !== "input" && tag !== "select" && tag !== "textarea") return;
        label.style.display = "block";
        label.style.marginBottom = "6px";
        label.style.lineHeight = "1.4";
    });
}

function applyPdfExportCloneFixes(clonedDoc, clonedRoot, mapDataUrlByKey, imageDataUrlBySrc) {
    if (!clonedDoc || !clonedRoot || typeof clonedRoot.querySelectorAll !== "function") return;

    applyPdfCloneLabelInputSpacing(clonedRoot);

    if (imageDataUrlBySrc instanceof Map && imageDataUrlBySrc.size) {
        clonedRoot.querySelectorAll("img").forEach((img) => {
            const raw =
                img.getAttribute("src") ||
                (typeof img.src === "string" ? img.src : "") ||
                "";
            const key = normalizePdfRemoteImageUrl(raw);
            if (!key) return;
            const inlined = imageDataUrlBySrc.get(key);
            if (!inlined) return;
            img.removeAttribute("crossorigin");
            try {
                img.crossOrigin = null;
            } catch {
                /* ignore */
            }
            img.src = inlined;
        });
    }

    clonedRoot.querySelectorAll("iframe[data-pdf-map-static]").forEach((iframe) => {
        const lat = iframe.getAttribute("data-lat");
        const lng = iframe.getAttribute("data-lng");
        if (lat == null || lng == null || String(lat).trim() === "" || String(lng).trim() === "") return;
        const parent = iframe.parentNode;
        if (!parent) return;
        const mapSrc = buildPdfStaticMapImageUrl(lat, lng);
        if (!mapSrc) return;
        const key = pdfMapCacheKey(lat, lng);
        const inlined =
            mapDataUrlByKey instanceof Map && typeof mapDataUrlByKey.get === "function"
                ? mapDataUrlByKey.get(key)
                : null;
        const wrap = clonedDoc.createElement("div");
        const img = clonedDoc.createElement("img");
        img.setAttribute("alt", "Mapa");
        img.style.width = "100%";
        img.style.maxWidth = "100%";
        img.style.height = "auto";
        img.style.minHeight = "200px";
        img.style.objectFit = "cover";
        img.style.border = "1px solid #e5e7eb";
        img.style.borderRadius = "6px";
        if (inlined) {
            img.src = inlined;
        } else {
            img.crossOrigin = "anonymous";
            img.src = mapSrc;
        }
        wrap.appendChild(img);
        const cap = clonedDoc.createElement("div");
        cap.textContent = "© OpenStreetMap contributors";
        cap.style.fontSize = "10px";
        cap.style.color = "#6b7280";
        cap.style.marginTop = "4px";
        wrap.appendChild(cap);
        parent.replaceChild(wrap, iframe);
    });
}

export const sharedExportarPdf = async (contentRef, nombreArchivo = 'Details', options = {}) => {
    if (!contentRef.current) return;
    const {
        onStart,
        onProgress,
        onFinish,
        onError,
    } = options || {};
    const el = contentRef.current;
    const prev = {
        overflow: el.style.overflow,
        maxHeight: el.style.maxHeight,
        height: el.style.height,
    };
    el.style.overflow = "visible";
    el.style.maxHeight = "none";
    el.style.height = "auto";
    await new Promise((r) => requestAnimationFrame(() => requestAnimationFrame(r)));

    const MARGIN_MM = 10;
    const BLOCK_GAP_MM = 2;
    const SLICE_OVERLAP_PX = 2;
    const MIN_SLICE_MM = 6;

    try {
        if (typeof onStart === "function") onStart();
        const pdf = new jsPDF("p", "mm", "letter");
        const pageW = pdf.internal.pageSize.getWidth();
        const pageH = pdf.internal.pageSize.getHeight();
        const contentW = pageW - MARGIN_MM * 2;
        // Letter printable width in CSS px (~96dpi) — applied only on the html2canvas clone (onclone), not the live modal
        const letterContentPx = Math.max(
            320,
            Math.round((contentW * 96) / 25.4)
        );

        const blocks = Array.from(el.querySelectorAll("[data-pdf-block]"));
        if (blocks.length === 0) {
            if (typeof onProgress === "function") onProgress({ current: 0, total: 0, percent: 100 });
            return;
        }
        if (typeof onProgress === "function") onProgress({ current: 0, total: blocks.length, percent: 0 });

        let y = MARGIN_MM;

        const roomBelowY = () => pageH - MARGIN_MM - y;

        const addContinuationPage = () => {
            pdf.addPage("p", "mm", "letter");
            y = MARGIN_MM;
        };

        const drawCanvasSlice = (sourceCanvas, srcYpx, sliceHpx) => {
            const sliceCanvas = document.createElement("canvas");
            sliceCanvas.width = sourceCanvas.width;
            sliceCanvas.height = sliceHpx;
            const ctx = sliceCanvas.getContext("2d");
            ctx.fillStyle = "#ffffff";
            ctx.fillRect(0, 0, sliceCanvas.width, sliceCanvas.height);
            ctx.drawImage(
                sourceCanvas,
                0,
                srcYpx,
                sourceCanvas.width,
                sliceHpx,
                0,
                0,
                sourceCanvas.width,
                sliceHpx
            );
            const sliceData = sliceCanvas.toDataURL("image/png");
            const drawH = (sliceHpx * contentW) / sourceCanvas.width;
            pdf.addImage(sliceData, "PNG", MARGIN_MM, y, contentW, drawH);
            y += drawH;
        };

        for (let blockIndex = 0; blockIndex < blocks.length; blockIndex++) {
            const block = blocks[blockIndex];
            const [mapDataUrlByKey, imageDataUrlBySrc] = await Promise.all([
                prefetchPdfMapTilesForBlock(block),
                prefetchPdfRemoteImagesForBlock(block),
            ]);
            // Do not pass width/height: <tr> and fragments report wrong scroll dims → clipped text.
            const canvas = await html2canvas(block, {
                // High scales can trigger memory pressure and render black pages.
                scale: Math.min(1.5, window.devicePixelRatio || 1),
                useCORS: true,
                logging: false,
                backgroundColor: "#ffffff",
                scrollX: 0,
                scrollY: 0,
                imageTimeout: 20000,
                onclone: (_clonedDoc, clonedBlock) => {
                    if (!clonedBlock?.style) return;
                    clonedBlock.style.boxSizing = "border-box";
                    clonedBlock.style.width = `${letterContentPx}px`;
                    clonedBlock.style.maxWidth = "none";
                    clonedBlock.style.overflow = "visible";
                    applyPdfExportCloneFixes(_clonedDoc, clonedBlock, mapDataUrlByKey, imageDataUrlBySrc);
                },
            });
            const blockHMM = (canvas.height * contentW) / canvas.width;

            if (blockHMM <= roomBelowY() + 0.02) {
                pdf.addImage(
                    canvas.toDataURL("image/png"),
                    "PNG",
                    MARGIN_MM,
                    y,
                    contentW,
                    blockHMM
                );
                y += blockHMM + BLOCK_GAP_MM;
                continue;
            }

            if (y > MARGIN_MM + 0.5) {
                addContinuationPage();
            }

            const fullPageRoom = pageH - 2 * MARGIN_MM;
            if (blockHMM <= fullPageRoom + 0.02) {
                pdf.addImage(
                    canvas.toDataURL("image/png"),
                    "PNG",
                    MARGIN_MM,
                    y,
                    contentW,
                    blockHMM
                );
                y += blockHMM + BLOCK_GAP_MM;
                continue;
            }

            let srcYpx = 0;
            while (srcYpx < canvas.height - 0.5) {
                if (roomBelowY() < MIN_SLICE_MM) {
                    addContinuationPage();
                    continue;
                }
                const remainingPx = canvas.height - srcYpx;
                const remainingMM = blockHMM * (remainingPx / canvas.height);
                const roomMM = roomBelowY();
                const sliceHMM = Math.min(remainingMM, roomMM);
                let sliceHpx = Math.round((sliceHMM / blockHMM) * canvas.height);
                sliceHpx = Math.max(1, Math.min(sliceHpx, remainingPx));
                drawCanvasSlice(canvas, srcYpx, sliceHpx);
                // Small overlap prevents anti-aliasing cuts where glyphs fall exactly on slice boundary.
                srcYpx += Math.max(1, sliceHpx - SLICE_OVERLAP_PX);
            }
            y += BLOCK_GAP_MM;
            if (typeof onProgress === "function") {
                const current = blockIndex + 1;
                onProgress({
                    current,
                    total: blocks.length,
                    percent: Math.round((current / blocks.length) * 100),
                });
            }
        }

        pdf.save(`${nombreArchivo}-${moment().format("YYYY-MM-DD-HHmm")}.pdf`);
    } catch (err) {
        console.warn("Export PDF err", err);
        if (typeof onError === "function") onError(err);
    } finally {
        el.style.overflow = prev.overflow;
        el.style.maxHeight = prev.maxHeight;
        el.style.height = prev.height;
        if (typeof onFinish === "function") onFinish();
    }
};

export const sharedNormalizeHexColor = (color) => {
    try {
        if (color == null || String(color).trim() === "") return "#6b7280";
        const s = String(color).trim();
        return s.startsWith("#") ? s : `#${s}`;
    } catch (err) {
        console.log('sharedNormalizeHexColor err');
        console.log(err);
        return "#6b7280";
    }
};

export const sharedObtenerIdEmpresa = () => {
    try {
        const idEmpresa = localStorage.getItem(STRING_ID_EMPRESA_ULTIMA_MILLA_V3);
        if (idEmpresa == null || idEmpresa === "") return null;
        return parseInt(idEmpresa);
    } catch (err) {
        console.log('sharedObtenerIdEmpresa err');
        console.log(err);
        return null;
    }
};

export const sharedCloneObject = (obj) => {
    try {
        return JSON.parse(JSON.stringify(obj));
    } catch (err) {
        console.log('sharedCloneObject err');
        console.log(err);
        return null;
    }
};

/** API may return react-select multi value as JSON string e.g. `[{"label":"…","value":6237}]`. */
export const sharedParseSelectMultiField = (raw) => {
    try {
        if (raw == null || raw === "") return null;
        if (Array.isArray(raw)) {
            return raw.length > 0 ? raw : null;
        }
        if (typeof raw === "string") {
            const trimmed = raw.trim();
            if (trimmed === "" || trimmed === "[]") return null;
            try {
                const parsed = JSON.parse(trimmed);
                return Array.isArray(parsed) && parsed.length > 0 ? parsed : null;
            } catch {
                return null;
            }
        }
        return null;
    } catch (error) {
        console.log('sharedParseSelectMultiField err');
        console.log(error);
        return null;
    }
};

/** react-select requires unique `value` per option; API may return duplicates across grupos. */
export const sharedDedupeSelectOptions = (options) => {
    if (!Array.isArray(options)) return [];
    const seen = new Set();
    const result = [];
    for (const opt of options) {
        const key = opt?.value;
        if (key == null || key === "" || seen.has(key)) continue;
        seen.add(key);
        result.push(opt);
    }
    return result;
};